import { Box, Button, Flex, Link, Text } from '@chakra-ui/react'
import { Wait, WarningTriangle } from '@components/icons'
import { openLinkInNewTab } from '@utilities'
import React from 'react'
import { useHistory } from 'react-router-dom'

interface UsageBasedPricingWarningBannerProps {
  type: 'out-of-sessions' | 'auto-replenish-failed'
  isFirstTimePurchase?: boolean
  isExtension?: boolean
}

export const UsageBasedPricingWarningBanner = ({
  type,
  isFirstTimePurchase = false,
  isExtension = false
}: UsageBasedPricingWarningBannerProps) => {
  const history = useHistory()

  const handleManagePlan = () => {
    isExtension
      ? openLinkInNewTab('/settings/plan/manage')
      : history.push('/settings/plan/manage')
  }

  const getBannerContent = () => {
    switch (type) {
      case 'out-of-sessions':
        return {
          backgroundColor: '#EB5164',
          icon: <WarningTriangle width="24px" fill="white" />,
          text: (
            <Text color="white">
              <Text as="span">You're out of sessions!</Text>
            </Text>
          ),
          buttonText: isFirstTimePurchase
            ? 'Get 50% Off Sessions'
            : 'Purchase Sessions'
        }
      case 'auto-replenish-failed':
        return {
          backgroundColor: '#FFF2F2',
          icon: <Wait />,
          text: (
            <Text color="black">
              <Text fontWeight="bold" as="span">
                Auto-replenish failed!{' '}
              </Text>
              Your automatic session replenishment was unsuccessful. Please
              update your payment method or purchase sessions manually.
            </Text>
          ),
          buttonText: 'Purchase Sessions'
        }
      default:
        return null
    }
  }

  const content = getBannerContent()
  if (!content) return null

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="100%"
      bg={content.backgroundColor}
      p={3}
      position="relative"
    >
      <Flex wrap="wrap" align="center" flex="1" justify="center">
        <Box mr={2}>{content.icon}</Box>
        <Text color="white" as="span">
          {content.text}
        </Text>
        <Link
          color="white"
          textDecoration="underline"
          fontSize="16px"
          ml={2}
          _hover={{ color: 'white', textDecoration: 'underline', opacity: 0.8 }}
          onClick={handleManagePlan}
          cursor="pointer"
        >
          {content.buttonText}
        </Link>
      </Flex>
    </Box>
  )
}
